export default "https://play.google.com/store/apps/details?id=br.com.mhi.retail";



// WEBPACK FOOTER //
// ./src/assets/enum/url/mhi/index.js